import { createFileRoute, redirect } from '@tanstack/react-router'
import { todosLinkOptions } from '~/features/dashboard/pages/quick-actions/pages/todos'

export const Route = createFileRoute('/(dashboard)/dashboard/$program/todos/')({
  beforeLoad: ({ params }) => {
    throw redirect(todosLinkOptions(params.program))
  },
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading todos</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})


